import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-139" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-140" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7-day money-back guarantee" data-id="element-141" data-mp="222wjc7wug0nm">
          <defs data-id="element-142" data-mp="19e7q0v214zmf">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-143" data-mp="19fsi8e0vg6h4" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-144" data-mp="14h8xui1xf2qv" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-145" data-mp="1j652e54rxxmq" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-146" data-mp="1ec97xcnpyswb">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-147" data-mp="qlwu5l5sm1xt">
              MONEY-BACK GUARANTEE · BUY WITH CONFIDENCE ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-148" data-mp="oxp1w1u3950d">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-149" data-mp="yqe03v0momdr">
            DAYS
          </text>
        </svg>

        <div data-id="element-150" data-mp="628gjblb93fi">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-151" data-mp="62qk6taayjxg">
            7-day money-back guarantee
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-152" data-mp="f0ako00ccc70">
            Download the material and try it in your own lessons. If the package doesn’t meet your
            expectations, email us within 7 days of your purchase and ask for a refund, according to the
            guarantee terms.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-153" data-mp="1vdr0bnm2d1d2">
            This guarantee does not affect your rights under applicable consumer law.
          </p>
        </div>
      </div>
    </section>;
}